export const Path = 'https://amplify-littlebillion-dev-171331-deployment.s3.us-east-2.amazonaws.com/uploads/';
export const setting_table_id='da461b02-500b-4865-b784-49c2d80ceb25';
export const admin_table_id='15ba63ce-2eb1-43c2-b912-e6d9f357da59';
export const bucketName='amplify-pricewatch-dev-133013-deployment';
export const dirName='uploads';
export const region='us-east-2';
export const accessKeyId='AKIA6KANT5TE4KQOFPXA';
export const secretAccessKey= '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';